module.exports = __webpack_public_path__ + "img/companycover-logo-white.383d218a.png";